import ReactDOM from 'react-dom/client';
import React, { lazy } from 'react';
import { HashRouter } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
const RenderApp = lazy(() => import('./renderApp'));
const root = ReactDOM.createRoot(document.getElementById('webedi-root'));

root.render(
    <ErrorBoundary>
        <HashRouter>
            <RenderApp />
        </HashRouter>
    </ErrorBoundary>
);
